module.exports = {
    config: {
        resourceRegisterKey: 'quickNav',
    },

    methods: {
        showPrev(){
            console.log('showPrev()', arguments)
        },
        showNext(){
            console.log('showNext()', arguments)
        },
    }
}